import type {
  Message,
  MessageAttachment,
  MessageAuthor,
  MessageMention,
} from '@/modules/connect/use-cases'

export type MessageAuthorDto = {
  id: string
  name?: string | null
}

export type MessageMentionDto = {
  userId: string
  name?: string | null
}

export type MessageAttachmentDto = {
  id: string
  storagePath: string
  contentType: string
  byteSize?: number | null
}

export type MessageDto = {
  id: string
  channelId: string
  author?: MessageAuthorDto | null
  body: string
  mentions?: MessageMentionDto[] | null
  attachments?: MessageAttachmentDto[] | null
  editedAt?: string | null
  deletedAt?: string | null
  createdAt: string
}

function toAuthor(dto: MessageAuthorDto): MessageAuthor {
  return {
    id: dto.id,
    name: dto.name ?? undefined,
  }
}

function toMention(dto: MessageMentionDto): MessageMention {
  return {
    userId: dto.userId,
    name: dto.name ?? undefined,
  }
}

function toAttachment(dto: MessageAttachmentDto): MessageAttachment {
  return {
    id: dto.id,
    storagePath: dto.storagePath,
    contentType: dto.contentType,
    byteSize: dto.byteSize ?? undefined,
  }
}

export function toMessage(dto: MessageDto): Message {
  return {
    id: dto.id,
    channelId: dto.channelId,
    author: dto.author ? toAuthor(dto.author) : undefined,
    body: dto.body,
    mentions: (dto.mentions ?? []).map(toMention),
    attachments: (dto.attachments ?? []).map(toAttachment),
    editedAt: dto.editedAt ?? undefined,
    deletedAt: dto.deletedAt ?? undefined,
    createdAt: dto.createdAt,
  }
}
